// import * as React from 'react';
// import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
// import MuiCard from '@mui/material/Card';
// import Checkbox from '@mui/material/Checkbox';
// import Divider from '@mui/material/Divider';
// import FormLabel from '@mui/material/FormLabel';
// import FormControl from '@mui/material/FormControl';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Link from '@mui/material/Link';
// import TextField from '@mui/material/TextField';
// import Typography from '@mui/material/Typography';
// import { styled } from '@mui/material/styles';
// import { LoginActions } from '../../Services/_actions/LoginAction/LoginAction.ts';
// import ReCAPTCHA from 'react-google-recaptcha';
// import Grid from '@mui/material/Grid';
// import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
// import LoadingButton from '../Shared/Loading/index.tsx';
// import ForgotPasswordModal from './ForgotPasswordModal.tsx';
// import GuestLoginModal from './GuestLoginModal.tsx';
// import { useRecoilValue, useSetRecoilState } from 'recoil';
// import { authAtom, userInformationAtom } from '../../Services/_states/auth.js';
// import { useLocation, useNavigate } from 'react-router';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { IconButton, InputAdornment } from '@mui/material';
// import MachadaloLogo from '../Header/machadalo-logo.png';
// import TestLogo from '../Header/synergytop-logo.webp';

// const Logo = process.env.REACT_APP_SUBDOMAIN_POSTFIX === '.synergytop.com' ? TestLogo : MachadaloLogo;

// const Card = styled(MuiCard)(({ theme }) => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignSelf: 'center',
//   width: '100%',
//   padding: theme.spacing(2),
//   gap: theme.spacing(2),
//   boxShadow:
//     'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
//   [theme.breakpoints.up('sm')]: {
//     width: '450px',
//   },
//   [theme.breakpoints.down('sm')]: {
//     padding: theme.spacing(2),
//   },
//   ...theme.applyStyles('dark', {
//     boxShadow:
//       'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
//   }),
// }));

// const CONSISTENT_KEY_B64 = process.env.REACT_APP_API_ENCRYPTION_KEY;
// const base64ToUint8Array = (b64) => Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));

// const getConsistentKey = async () => {
//   const keyBuffer = base64ToUint8Array(CONSISTENT_KEY_B64);
//   const key = await crypto.subtle.importKey('raw', keyBuffer, 'AES-GCM', false, ['encrypt', 'decrypt']);
//   return key;
// };

// const encryptData = async (plainText) => {
//   const key = await getConsistentKey();
//   const iv = crypto.getRandomValues(new Uint8Array(12));
//   const encodedText = new TextEncoder().encode(plainText);

//   const encryptedBuffer = await crypto.subtle.encrypt(
//     { name: 'AES-GCM', iv: iv },
//     key,
//     encodedText
//   );

//   const combined = new Uint8Array(iv.byteLength + encryptedBuffer.byteLength);
//   combined.set(iv, 0);
//   combined.set(new Uint8Array(encryptedBuffer), iv.byteLength);

//   // Return as base64
//   const base64 = btoa(String.fromCharCode(...combined));
//   return base64;
// };

// const decryptData = async (encryptedB64) => {
//   const key = await getConsistentKey();
//   const encrypted = base64ToUint8Array(encryptedB64);

//   const iv = encrypted.slice(0, 12);
//   const ciphertextWithTag = encrypted.slice(12);

//   const decryptedBuffer = await crypto.subtle.decrypt(
//     { name: 'AES-GCM', iv },
//     key,
//     ciphertextWithTag
//   );

//   const decryptedText = new TextDecoder().decode(decryptedBuffer);
//   return decryptedText;
// };

// // Updated function - no longer generates new keys
// const encryptDataPayload = async (data) => {
//   const encryptedData = await encryptData(JSON.stringify(data));
//   const payload = {
//     encrypted_data: encryptedData,
//     // No key field needed since we're using consistent key
//   };
//   return payload;
// };

// // Function to decrypt response from backend
// const decryptResponsePayload = async (encryptedResponse) => {
//   const decryptedJson = await decryptData(encryptedResponse);
//   return JSON.parse(decryptedJson);
// };

// export default function SignInCard() {
//   // const theme = useTheme();
//   // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const action = LoginActions();
//   const [credential, setCredential] = React.useState({ username: "", password: "" });
//   const [rememberMe, setRememberMe] = React.useState(true);
//   const [guestModalOpen, setGuestModalOpen] = React.useState(false);
//   const [captchaToken, setCaptchaToken] = React.useState(null);
//   const [loginError, setLoginError] = React.useState('');
//   const [isLoginInProgress, setIsLoginInProgress] = React.useState(false);
//   const [forgotPasswordModalOpen, setForgotPasswordModalOpen] = React.useState(false);
//   const [isSubmitting, setIsSubmitting] = React.useState(false);
//   const setUserInfo = useSetRecoilState(userInformationAtom);
//   const { showSnackBar } = useSnackBar();
//   const setAuth = useSetRecoilState(authAtom);  // Set authAtom
//   const auth = useRecoilValue(authAtom);
//   const navigate = useNavigate();
//   const Location = useLocation();
//   const [showPassword, setShowPassword] = React.useState(false);

//   const handleCaptchaChange = (token) => {
//     setCaptchaToken(token);
//   };

//   const navigateToDashboard = (userPermissions = {}) => {
//   if (
//     userPermissions.hasOwnProperty('campaign_leads_page_access') &&
//     userPermissions['campaign_leads_page_access']
//   ) {
//     navigate('/r/records/v1');
//     return;
//   }

//   if (
//     userPermissions.hasOwnProperty('homepage_access') &&
//     userPermissions['homepage_access']
//   ) {
//     navigate('/r/management/manageCampaign');
//     return;
//   }

//   if (
//     userPermissions.hasOwnProperty('whatsapp_template_access') &&
//     userPermissions['whatsapp_template_access']
//   ) {
//     navigate('/r/whatsapp/template-list');
//     return;
//   }
 
//   // if (
//   //   userPermissions.hasOwnProperty('can_view_concept_builder') &&
//   //   userPermissions['can_view_concept_builder']
//   // ) {
//   //   navigate('/r/student/concept-builder');
//   //   return;
//   // }
//   navigate('/r/student/concept-builder');
// };


//   React.useEffect(() => {
//     if (auth?.token && Location.pathname === '/r/login') {
//       // navigate('/r/management/manageCampaign');
//       try {
//         const userData = JSON.parse(localStorage.getItem('userInfo'));
//         if (userData?.profile?.permissions) {
//           const permissions = userData?.profile?.permissions;
//           navigateToDashboard(permissions);
//         }
//       } catch (error) {
//         navigate('/r/leads/v1');
//         console.log(error);
//       }
//     }
//   }, [auth, navigate]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoginError('');
//     if (!credential.username || !credential.password) {
//       if (!credential.username && !credential.password) {
//         setLoginError('Username and Password are required.');
//       } else if (!credential.username) {
//         setLoginError('Username is required.');
//       } else if (!credential.password) {
//         setLoginError('Password is required.');
//       }
//       return;
//     }
//     if (!captchaToken) {
//       setLoginError('Please complete the reCAPTCHA.');
//       return;
//     }
//     setIsLoginInProgress(true);
//     try {
//       // const encryptedPayload = await encryptDataPayload(credential)
//       const encryptedResponse = await action.login(credential);
//       let response = {};
//       if (encryptedResponse?.status === 200 && encryptedResponse?.data) {
//         // response = await decryptResponsePayload(encryptedResponse?.data?.encrypted_data);
//         response = encryptedResponse?.data;
//         localStorage.setItem('machadalo-credentials', JSON.stringify(response));
//         // setAuth({
//         //   token: response?.data?.token,
//         //   isAuthenticated: true,
//         //   user: response?.data?.user,
//         // });
//         await fetchUserInfo(response);
//       } else {
//        const apiError = encryptedResponse?.data;
//   if (apiError?.non_field_errors?.length) {
//     setLoginError(apiError.non_field_errors[0]);
//   } else {
//     setLoginError('Invalid credentials. Please try again.');
//   }
//        // setLoginError(response?.data?.non_field_errors?.[0] ?? 'Invalid credentials');
//       }
//     } catch (error) {
//       setLoginError('Login failed. Please try again.');
//     } finally {
//       setIsLoginInProgress(false);
//       // Consider resetting captchaToken(null) here if needed
//     }
//   };

//   const fetchUserInfo = async (authResponse) => {
//     try {
//       const userInfoResponse = await action.userInformation(authResponse?.user_id);
//       if (userInfoResponse?.status === 200 && userInfoResponse?.data) {
//         const userData = userInfoResponse.data;
//         const subDomain = userData?.profile?.organisation?.sub_domain;
//         const postfix = process.env.REACT_APP_SUBDOMAIN_POSTFIX ?? '.machadalo.com';
//         const newDomain = `${subDomain}${postfix}`;
//         // if (window?.location?.hostname === 'localhost') {
//         //   console.log('Running on localhost, no redirection needed');
//         // } else 

//         if (!subDomain && (window?.location?.origin === process.env.REACT_APP_ORIGIN)) {
//           console.log('');
//         } else if (subDomain && window.location.host === newDomain) {
//           console.log('');
//         } else {
//           localStorage.clear();
//           setAuth(null);
//           setLoginError("Invalid Credentials")
//           // if (subDomain) {
//           //   setRedirectDomain(newDomain);
//           //   setIsConfirmOpen(true);
//           //   return;
//           // }
//           // window.location.href = `https://${newDomain}`;
//           return;
//         }
//         setAuth({
//           token: authResponse?.token,
//           isAuthenticated: true,
//           user: authResponse?.user,
//         });
//         if (userData?.profile?.organisation)
//           if (userData.profile) {
//             const permissions = {};
//             (userData.profile.general_user_permission || []).forEach(perm => {
//               permissions[perm.name.toLowerCase()] = perm.is_allowed;
//             });
//             userData.profile.permissions = permissions;
//           }
//         localStorage.setItem('userInfo', JSON.stringify(userData));
//         setUserInfo(userData); // Update Recoil state
//         // setTimeout(() => {
//         //   navigate('/r/management/manageCampaign');
//         // }, 500);

//         const userPermissions = userData?.profile?.permissions;
//         navigateToDashboard(userPermissions);
//         // if (
//         //   userPermissions.hasOwnProperty('campaign_leads_page_access') &&
//         //   userPermissions['campaign_leads_page_access']
//         // ) {
//         //   navigate('/r/leads/v1');
//         // }
//         // else if (userPermissions.hasOwnProperty('homepage_access') && userPermissions['homepage_access']) {
//         //   navigate('/r/management/manageCampaign');
//         // } else {
//         //   navigate('/r/whatsapp/template-list');
//         // }
//       } else {
//         console.error('Failed to fetch user info, status:', userInfoResponse?.status, 'data:', userInfoResponse?.data);
//       }
//     } catch (error) {
//       console.error('Failed to fetch user info:', error);
//     }
//   };
//   // const handleConfirm = (confirmed: boolean) => {
//   //   if (confirmed) {
//   //     console.log(confirmed, "True")
//   //     if (redirectDomain) {
//   //       if (window.location.hostname === 'localhost') {
//   //         window.location.href = `http://${redirectDomain}`;
//   //       } else {
//   //         window.location.href = `https://${redirectDomain}`;
//   //       }
//   //     }
//   //   } else {
//   //     console.log(confirmed, "False")
//   //   }
//   // }

//   return (
//     <>
//       <Card variant="outlined">
//         <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
//           <img
//             src={Logo}
//             alt="Synergytop Logo"
//             style={{ maxWidth: 100 }}
//           />

//         </Box>
//         <Typography
//           component="h1"
//           variant="h4"
//           sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
//         >
//           Sign in
//         </Typography>
//         {loginError && (
//           <Typography color="error" variant="body2" mb={2}>
//             {loginError}
//           </Typography>
//         )}
//         <Box
//           component="form"
//           onSubmit={handleSubmit}
//           noValidate
//           sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 2 }}
//         >
//           <FormControl>
//             <FormLabel htmlFor="email">Username</FormLabel>
//             <TextField
//               id="username"
//               placeholder='Enter your username'
//               type="text"
//               name="username"
//               size='small'
//               autoComplete="username"
//               value={credential?.username ?? ""}
//               onChange={(e) => setCredential({ ...credential, username: e.target.value })}
//               required
//               fullWidth
//               error={!!loginError && !credential.username}
//               helperText={!!loginError && !credential.username ? 'Username is required' : ''}
//             />
//           </FormControl>
//           <FormControl>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//               <FormLabel htmlFor="password">Password</FormLabel>
//             </Box>
//             <TextField
//               id="password"
//               placeholder='Enter your password'
//               type={showPassword ? 'text' : 'password'}
//               name="password"
//               size='small'
//               autoComplete="current-password"
//               value={credential?.password ?? ""}
//               onChange={(e) => setCredential({ ...credential, password: e.target.value })}
//               required
//               fullWidth
//               error={!!loginError && !credential.password}
//               helperText={!!loginError && !credential.password ? 'Password is required' : ''}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((prev) => !prev)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}

//             />
//           </FormControl>
//           {/* <FormControlLabel
//           control={
//             <Checkbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} color="primary" />}
//           label="Remember me"
//         /> */}
//           <Box mt={2} display="flex" justifyContent="start">
//             {window?.location?.hostname === 'localhost' ? (
//               <ReCAPTCHA
//                 sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
//                 onChange={handleCaptchaChange}
//               />
//             ) : (
//               <ReCAPTCHA
//                 sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
//                 onChange={handleCaptchaChange}
//               />
//             )}
//           </Box>

//           {/* <ForgotPassword open={open} handleClose={handleClose} /> */}

//           <LoadingButton
//             variant="contained"
//             size='small'
//             type="submit"
//             buttonName="Sign in"
//             isLoading={isLoginInProgress}
//           // onClickButton={handleSubmit}
//           />

//           {/* <Button type="submit" fullWidth variant="contained">
//           Sign in
//         </Button> */}
//           <Grid container mt={1} justifyContent="space-between">
//             {/* <Grid item>
//             <Button
//               onClick={() => setGuestModalOpen(true)}
//               sx={{ alignSelf: 'center' }}
//             >
//               Continue as Guest
//             </Button>
//           </Grid> */}
//             <Grid item>
//               <Button onClick={(e) => { setForgotPasswordModalOpen(true); }}>
//                 Forgot Password ?
//               </Button>
//             </Grid>
//           </Grid>
//         </Box>
//       </Card>
//       {/* <ConfirmBox
//         open={isConfirmOpen}
//         onClose={(confirmed: boolean) => {
//           handleConfirm(confirmed);
//           setIsConfirmOpen(false);
//         }}
//         options={{
//           title: 'Redirect Required',
//           text: <Typography variant="body1" gutterBottom>
//             You are currently on <strong>{window.location.host}</strong>, but
//             your organisation belongs to{" "}
//             <strong>{redirectDomain ?? ''}</strong>.
//           </Typography>,
//           confirmButtonText: `Go to ${redirectDomain ?? ''}`,
//           cancelButtonText: 'Cancel',
//           confirmButtonColor: 'warning',
//           cancelButtonColor: 'default',
//         }}
//       /> */}
//       <GuestLoginModal
//         open={guestModalOpen}
//         onClose={() => setGuestModalOpen(false)}
//       />
//       <ForgotPasswordModal open={forgotPasswordModalOpen} onClose={() => setForgotPasswordModalOpen(false)} />
//     </>

//   );
// }


import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { LoginActions } from '../../Services/_actions/LoginAction/LoginAction.ts';
import ReCAPTCHA from 'react-google-recaptcha';
import Grid from '@mui/material/Grid';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import LoadingButton from '../Shared/Loading/index.tsx';
import ForgotPasswordModal from './ForgotPasswordModal.tsx';
import GuestLoginModal from './GuestLoginModal.tsx';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { authAtom, userInformationAtom } from '../../Services/_states/auth.js';
import { useLocation, useNavigate } from 'react-router';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, Chip } from '@mui/material';
import MachadaloLogo from '../Header/machadalo-logo.png';
import TestLogo from '../Header/synergytop-logo.webp';
import PsychologyIcon from '@mui/icons-material/Psychology';
import { useSearchParams } from 'react-router-dom';

const Logo = process.env.REACT_APP_SUBDOMAIN_POSTFIX === '.synergytop.com' ? TestLogo : MachadaloLogo;

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(3),
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

const CONSISTENT_KEY_B64 = process.env.REACT_APP_API_ENCRYPTION_KEY;
const base64ToUint8Array = (b64) => Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));

const getConsistentKey = async () => {
  const keyBuffer = base64ToUint8Array(CONSISTENT_KEY_B64);
  const key = await crypto.subtle.importKey('raw', keyBuffer, 'AES-GCM', false, ['encrypt', 'decrypt']);
  return key;
};

const encryptData = async (plainText) => {
  const key = await getConsistentKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encodedText = new TextEncoder().encode(plainText);

  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv: iv },
    key,
    encodedText
  );

  const combined = new Uint8Array(iv.byteLength + encryptedBuffer.byteLength);
  combined.set(iv, 0);
  combined.set(new Uint8Array(encryptedBuffer), iv.byteLength);

  // Return as base64
  const base64 = btoa(String.fromCharCode(...combined));
  return base64;
};

const decryptData = async (encryptedB64) => {
  const key = await getConsistentKey();
  const encrypted = base64ToUint8Array(encryptedB64);

  const iv = encrypted.slice(0, 12);
  const ciphertextWithTag = encrypted.slice(12);

  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    key,
    ciphertextWithTag
  );

  const decryptedText = new TextDecoder().decode(decryptedBuffer);
  return decryptedText;
};

// Updated function - no longer generates new keys
const encryptDataPayload = async (data) => {
  const encryptedData = await encryptData(JSON.stringify(data));
  const payload = {
    encrypted_data: encryptedData,
    // No key field needed since we're using consistent key
  };
  return payload;
};

// Function to decrypt response from backend
const decryptResponsePayload = async (encryptedResponse) => {
  const decryptedJson = await decryptData(encryptedResponse);
  return JSON.parse(decryptedJson);
};

export default function SignInCard() {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const action = LoginActions();
  const [credential, setCredential] = React.useState({ username: "", password: "" });
  const [rememberMe, setRememberMe] = React.useState(true);
  const [guestModalOpen, setGuestModalOpen] = React.useState(false);
  const [captchaToken, setCaptchaToken] = React.useState(null);
  const [loginError, setLoginError] = React.useState('');
  const [isLoginInProgress, setIsLoginInProgress] = React.useState(false);
  const [forgotPasswordModalOpen, setForgotPasswordModalOpen] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const setUserInfo = useSetRecoilState(userInformationAtom);
  const { showSnackBar } = useSnackBar();
  const setAuth = useSetRecoilState(authAtom);  // Set authAtom
  const auth = useRecoilValue(authAtom);
  const navigate = useNavigate();
  const Location = useLocation();
  const [showPassword, setShowPassword] = React.useState(false);
 const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const password = searchParams.get('password');

  React.useEffect(() => {
    if (username || password) {
      setCredential({
        username: username ?? "",
        password: password ?? "",
      });
    }
  }, [username, password]);

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const navigateToDashboard = (userPermissions: any = {}) => {
  // ✅ Records
  if (userPermissions?.campaign_leads_page_access) {
    navigate('/r/records/v1');
    return;
  }

  // ✅ Homepage
  if (userPermissions?.homepage_access) {
    navigate('/r/management/manageCampaign');
    return;
  }

  // ✅ Whatsapp Template Dashboard
  if (
    userPermissions?.can_view_template_dashboard_new ||
    userPermissions?.whatsapp_template_access
  ) {
    navigate('/r/whatsapp/template-list');
    return;
  }

  // ✅ Intervene Dashboard
  if (userPermissions?.can_view_intervene_new) {
    navigate('/r/intervene-dashboard');
    return;
  }

  // ✅ Flow Builder
  if (userPermissions?.can_view_flow_builder) {
    navigate('/r/flow/list');
    return;
  }

  // ✅ Web Form
  if (userPermissions?.can_view_web_form) {
    navigate('/r/lead-web-form/');
    return;
  }

  // ✅ E-commerce
  if (userPermissions?.can_view_ecommerce_dashboard) {
    navigate('/r/e-commerce/orders');
    return;
  }

  if (userPermissions?.can_view_concept_builder) {
        navigate('/r/student/concept-builder');
        return;
      }

   navigate('/r/student/concept-builder');

  // ✅ Safe fallback
  navigate('/r/login');
};


  React.useEffect(() => {
    if (auth?.token && Location.pathname === '/r/login') {
      // navigate('/r/management/manageCampaign');
      try {
        const userData = JSON.parse(localStorage.getItem('userInfo'));
        if (userData?.profile?.permissions) {
          const permissions = userData?.profile?.permissions;
          navigateToDashboard(permissions);
        }
      } catch (error) {
        navigate('/r/leads/v1');
        console.log(error);
      }
    }
  }, [auth, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    if (!credential.username || !credential.password) {
      if (!credential.username && !credential.password) {
        setLoginError('Username and Password are required.');
      } else if (!credential.username) {
        setLoginError('Username is required.');
      } else if (!credential.password) {
        setLoginError('Password is required.');
      }
      return;
    }
    if (!captchaToken) {
      setLoginError('Please complete the reCAPTCHA.');
      return;
    }
    setIsLoginInProgress(true);
    try {
      // const encryptedPayload = await encryptDataPayload(credential)
      const encryptedResponse = await action.login(credential);
      let response = {};
      if (encryptedResponse?.status === 200 && encryptedResponse?.data) {
        // response = await decryptResponsePayload(encryptedResponse?.data?.encrypted_data);
        response = encryptedResponse?.data;
        localStorage.setItem('machadalo-credentials', JSON.stringify(response));
        // setAuth({
        //   token: response?.data?.token,
        //   isAuthenticated: true,
        //   user: response?.data?.user,
        // });
        await fetchUserInfo(response);
      } else {
        const apiError = encryptedResponse?.data;
        if (apiError?.non_field_errors?.length) {
          setLoginError(apiError.non_field_errors[0]);
        } else {
          setLoginError('Invalid credentials. Please try again.');
        }
        // setLoginError(response?.data?.non_field_errors?.[0] ?? 'Invalid credentials');
      }
    } catch (error) {
      setLoginError('Login failed. Please try again.');
    } finally {
      setIsLoginInProgress(false);
      // Consider resetting captchaToken(null) here if needed
    }
  };

  const fetchUserInfo = async (authResponse) => {
    try {
      const userInfoResponse = await action.userInformation(authResponse?.user_id);
      if (userInfoResponse?.status === 200 && userInfoResponse?.data) {
        const userData = userInfoResponse.data;
        const subDomain = userData?.profile?.organisation?.sub_domain;
        const postfix = process.env.REACT_APP_SUBDOMAIN_POSTFIX ?? '.machadalo.com';
        const newDomain = `${subDomain}${postfix}`;
        // if (window?.location?.hostname === 'localhost') {
        //   console.log('Running on localhost, no redirection needed');
        // } else 

        if (!subDomain && (window?.location?.origin === process.env.REACT_APP_ORIGIN)) {
          console.log('');
        } else if (subDomain && window.location.host === newDomain) {
          console.log('');
        } else {
          localStorage.clear();
          setAuth(null);
          setLoginError("Invalid Credentials")
          // if (subDomain) {
          //   setRedirectDomain(newDomain);
          //   setIsConfirmOpen(true);
          //   return;
          // }
          // window.location.href = `https://${newDomain}`;
          return;
        }
        setAuth({
          token: authResponse?.token,
          isAuthenticated: true,
          user: authResponse?.user,
        });
        if (userData?.profile?.organisation)
          if (userData.profile) {
            const permissions = {};
            (userData.profile.general_user_permission || []).forEach(perm => {
              permissions[perm.name.toLowerCase()] = perm.is_allowed;
            });
            userData.profile.permissions = permissions;
          }
        localStorage.setItem('userInfo', JSON.stringify(userData));
        setUserInfo(userData); // Update Recoil state
        // setTimeout(() => {
        //   navigate('/r/management/manageCampaign');
        // }, 500);

        const userPermissions = userData?.profile?.permissions;
        navigateToDashboard(userPermissions);
        // if (
        //   userPermissions.hasOwnProperty('campaign_leads_page_access') &&
        //   userPermissions['campaign_leads_page_access']
        // ) {
        //   navigate('/r/leads/v1');
        // }
        // else if (userPermissions.hasOwnProperty('homepage_access') && userPermissions['homepage_access']) {
        //   navigate('/r/management/manageCampaign');
        // } else {
        //   navigate('/r/whatsapp/template-list');
        // }
      } else {
        console.error('Failed to fetch user info, status:', userInfoResponse?.status, 'data:', userInfoResponse?.data);
      }
    } catch (error) {
      console.error('Failed to fetch user info:', error);
    }
  };
  // const handleConfirm = (confirmed: boolean) => {
  //   if (confirmed) {
  //     console.log(confirmed, "True")
  //     if (redirectDomain) {
  //       if (window.location.hostname === 'localhost') {
  //         window.location.href = `http://${redirectDomain}`;
  //       } else {
  //         window.location.href = `https://${redirectDomain}`;
  //       }
  //     }
  //   } else {
  //     console.log(confirmed, "False")
  //   }
  // }

  return (
    <>
      <Card variant="outlined">
        {/* Mobile Logo Header */}
        <Box sx={{ 
          display: { xs: 'flex', md: 'none' }, 
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: 1,
          mb: 2
        }}>
          <img
            src={Logo}
            alt="Logo"
            style={{ maxWidth: 100 }}
          />
          <Chip 
            icon={<PsychologyIcon />}
            label="DeTAiL - AI Powered Learning"
            color="primary"
            variant="outlined"
            size="small"
          />
        </Box>

        <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
          <Typography
            component="h1"
            variant="h4"
            sx={{ 
              width: '100%', 
              fontSize: 'clamp(1.75rem, 10vw, 2.15rem)',
              fontWeight: 700,
              mb: 0.5
            }}
          >
            Sign in
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'text.secondary',
              display: { xs: 'block', md: 'none' }
            }}
          >
            Access your personalized learning platform
          </Typography>
        </Box>

        {loginError && (
          <Box 
            sx={{ 
              p: 1.5, 
              bgcolor: 'error.lighter', 
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'error.light'
            }}
          >
            <Typography color="error" variant="body2">
              {loginError}
            </Typography>
          </Box>
        )}

        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 2 }}
        >
          <FormControl>
            <FormLabel htmlFor="email">Username</FormLabel>
            <TextField
              id="username"
              placeholder='Enter your username'
              type="text"
              name="username"
              size='small'
              autoComplete="username"
              value={credential?.username ?? ""}
              onChange={(e) => setCredential({ ...credential, username: e.target.value })}
              required
              fullWidth
              error={!!loginError && !credential.username}
              helperText={!!loginError && !credential.username ? 'Username is required' : ''}
            />
          </FormControl>
          <FormControl>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <FormLabel htmlFor="password">Password</FormLabel>
            </Box>
            <TextField
              id="password"
              placeholder='Enter your password'
              type={showPassword ? 'text' : 'password'}
              name="password"
              size='small'
              autoComplete="current-password"
              value={credential?.password ?? ""}
              onChange={(e) => setCredential({ ...credential, password: e.target.value })}
              required
              fullWidth
              error={!!loginError && !credential.password}
              helperText={!!loginError && !credential.password ? 'Password is required' : ''}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>

          <Box mt={2} display="flex" justifyContent="center">
            {window?.location?.hostname === 'localhost' ? (
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
                size="small"
              />
            ) : (
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
                size="small"
              />
            )}
          </Box>

          <LoadingButton
            variant="contained"
            size='small'
            type="submit"
            buttonName="Sign in"
            isLoading={isLoginInProgress}
            sx={{ 
              // py: 1.2,
              // fontSize: '16px',
              // fontWeight: 600
            }}
          />

          <Grid container justifyContent="center">
            <Grid item>
              <Button 
                onClick={(e) => { setForgotPasswordModalOpen(true); }}
                size="small"
              >
                Forgot Password?
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 1, display: { xs: 'block', md: 'none' } }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Powered by Deep AI
          </Typography>
        </Divider>
      </Card>

      <GuestLoginModal
        open={guestModalOpen}
        onClose={() => setGuestModalOpen(false)}
      />
      <ForgotPasswordModal open={forgotPasswordModalOpen} onClose={() => setForgotPasswordModalOpen(false)} />
    </>
  );
}